'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GateIcon = function GateIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M41.51 31.607l-2.568-3.044 1.284-3.508L43.876 24H90.05l2.162 2.868v3.045l-2.162 1.694h-9.017l-12.269 6.455v6.444h4.066v7.618h-4.805l.74 6.592h11.51v10.228l-6.004.818v6.267l11.751 4.435 6.19-1.823v-6.918h8.5v6.918h9.146v20.102h-9.146v7.804h-8.5v-6.75l-5.377-1.852-9.756 3.675-9.885 1.212-8.555-1.212-12.435-2.877-1.645-.798-5.617 1.852v6.75h-8.5v-7.804L21 97.945V78.64l9.442.808v-7.726l8.5.64v6.278l5.617 1.823 10.236-3.607 3.03-.828v-6.267h-6.152V58.716h11.77v-6.592H59.6v-7.618h3.843v-6.444l-12.565-5.637z'
            }),
            _react2.default.createElement('path', {
                d: 'M92.675 105.142h6.348v-32.5h-6.348v32.5zm-2.037-7.224V79.865l-3.87.748V97.17l3.87.748zm-5.906-17.471a50.623 50.623 0 0 0-39.499 0V97.34a50.623 50.623 0 0 0 39.499 0V80.447zM39.327 97.918l3.868-.748V80.613l-3.868-.748v18.053zm-8.384 7.224h6.347v-32.5h-6.347v32.5zM58.19 74.857a52.727 52.727 0 0 1 14.252.088v-5.037H58.19v4.949zm-6.002-10.07v3.083h26.257v-8.203H52.188v5.12zm11.787-7.157h2.68v-4.603h-2.68v4.603zm-4.357-6.638h11.395V45.45H59.618v5.542zm4.357-7.579h2.68V38.28h-2.68v5.133zm-11.468-11.05l10.631 3.88h4.354l10.391-3.88H52.507zm-10.269-2.036h46.155a2.246 2.246 0 0 0 2.245-2.245v-.8a2.248 2.248 0 0 0-2.245-2.247H42.238a2.247 2.247 0 0 0-2.243 2.247v.8a2.246 2.246 0 0 0 2.243 2.245zm58.82 49.323v17.29h8.539v2.037h-8.539v8.201h-10.42v-7.186l-4.785-.925a52.56 52.56 0 0 1-20.871 4.32 52.56 52.56 0 0 1-20.872-4.32l-4.783.925v7.186h-10.42v-8.201H20V96.94h8.907V79.65H20v-2.037h8.907v-7.008h10.42v7.187l4.788.925a52.31 52.31 0 0 1 12.038-3.557v-5.252H50.15v-12.28h11.79v-4.603h-4.358v-9.613h4.358v-5.439l-15.372-5.61h-4.33a4.288 4.288 0 0 1-4.281-4.281v-.8A4.288 4.288 0 0 1 42.238 23h46.155a4.288 4.288 0 0 1 4.282 4.282v.8a4.288 4.288 0 0 1-4.282 4.281h-4.69L68.69 37.967v5.445h4.36v9.613h-4.36v4.603H80.482v12.28H74.48v5.372c3.88.712 7.697 1.85 11.368 3.437l4.79-.925v-7.189h10.419v7.009h8.54v2.036h-8.539v.002zm-68.063 1.4h2.215v-2.037h-2.215v2.037zm0 9.145h2.215v-2.037h-2.215v2.037zm0 9.145h2.215v-2.037h-2.215v2.037zm61.732-18.29h2.215v-2.037h-2.215v2.037zm0 9.145h2.215v-2.037h-2.215v2.037zm0 9.143h2.215v-2.036h-2.215v2.036z',
                fill: '#555'
            }),
            _react2.default.createElement('path', {
                fill: '#555',
                fillRule: 'nonzero',
                d: 'M50.632 64.602v-1.666H72.3v1.666zM73.966 64.602v-1.666h5v1.666z'
            })
        )
    );
};

GateIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var Gate = function (_React$Component) {
    _inherits(Gate, _React$Component);

    function Gate() {
        _classCallCheck(this, Gate);

        return _possibleConstructorReturn(this, (Gate.__proto__ || Object.getPrototypeOf(Gate)).apply(this, arguments));
    }

    _createClass(Gate, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(GateIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return Gate;
}(_react2.default.Component);

exports.default = Gate;